import { render, staticRenderFns } from "./CoPriceFormGroup.vue?vue&type=template&id=1dc927d0&"
import script from "./CoPriceFormGroup.vue?vue&type=script&lang=js&"
export * from "./CoPriceFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports